import { Button, Stack } from '@landler/component-library';
import { useTranslation } from 'react-i18next';

import { useAuth } from '@/lib/auth';

export const LogOutPill = () => {
  const { t } = useTranslation();
  const { signOutAndInvalidateSession } = useAuth();

  return (
    <Stack direction='row' spacing={2} centerMain className='px-6 pt-2'>
      <Button
        onClick={signOutAndInvalidateSession}
        variant='text'
        className='text-text-primary justify-start w-full rounded-md hover:rounded-md text-left leading-[130%]'
      >
        <i className='ri-logout-box-r-line text-xl' />
        <span className='typography-body1'>{t('logout.title')}</span>
      </Button>
    </Stack>
  );
};
